import React from 'react';
import styled from 'styled-components';

import useTranslation from 'hooks/use-translation';
import { mediaQueries } from 'src/theme';
import { useModals } from 'src/components/modals';
import { ModalNames } from 'src/components/modals/modals.types';
import { InfoCircleOutline } from 'src/svg/info-circle-outline';

export default function DiscountToCartSection(props) {
  const { t } = useTranslation();
  const { displayTopBorder, specialName, isMobile, special } = props;
  const { openModal } = useModals();

  // Data now comes directly from price cart response - no more joining needed!
  const isRestrictedDiscount = special?.isRestricted === true;
  // Show info icon for all restricted discounts (use name as fallback)
  const showInfoIcon = isRestrictedDiscount;

  const displayName = special?.menuDisplayName ?? specialName;

  const handleInfoClick = () => {
    openModal(ModalNames.discountQualification, {
      name: displayName,
      description: special?.menuDisplayDescription,
      image: special?.menuDisplayImage,
      specialId: special?._id,
    });
  };

  return (
    <DiscountToCartSectionWrapper isMobile={isMobile} displayTopBorder={displayTopBorder}>
      {displayTopBorder && <StyledLine />}
      <ContentWrapper isMobile={isMobile}>
        <NameContainer>
          <SpecialName>{displayName}</SpecialName>
          {showInfoIcon && (
            <InfoButton
              onClick={handleInfoClick}
              aria-label={`View details for ${displayName}`}
              data-testid='discount-info-button'
            >
              <InfoCircleOutline />
            </InfoButton>
          )}
        </NameContainer>
        &nbsp;
        <AppliedBadge>
          <CheckImage alt='Checkmark Icon' src='/icons/green-checkmark.svg' />
          {t('common.discountToCartApplied', 'Applied')}
        </AppliedBadge>
      </ContentWrapper>
    </DiscountToCartSectionWrapper>
  );
}

const StyledLine = styled.hr`
  width: 90%;
  height: 0.669725px;
  background-color: ${({ theme }) => theme.colors.blueGrey[80]};
  border-style: none;
  margin-block-start: unset;
  margin-block-end: unset;
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ isMobile }) => (isMobile ? `8px 25px` : `10px 30px`)};
`;

const DiscountToCartSectionWrapper = styled.div`
  background: ${({ theme }) => theme.colors.darkBackground};
  font-size: ${({ isMobile }) => (isMobile ? `12px` : `14px`)};
  line-height: 175%;
`;

const CheckImage = styled.img`
  width: 11px;
  height: 9px;
  margin-right: 4px;
`;

const AppliedBadge = styled.span`
  font-weight: bold;
  font-size: 13px;
  line-height: 165%;
  color: ${({ theme }) => theme.colors.primaryGreen};
`;

const NameContainer = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const SpecialName = styled.span`
  font-weight: bold;
  max-width: 400px;

  @media ${mediaQueries.phone} {
    max-width: 250px;
  }
`;

const InfoButton = styled.button`
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: color 0.2s ease, background-color 0.2s ease;

  &:hover {
    color: #333;
    background-color: rgba(0, 0, 0, 0.05);
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.primaryGreen};
    outline-offset: 1px;
  }
`;
